import OMT_UI_DrawUtil from '../../../OMT_UI/Drawing/OMT_UI_DrawUtil';

/**
 * Class for the RequestHelp inventory
 * @author Sandra Koo
 */
export class RequestHelp_Inventory {
  /**
     * The inventory for requestHelp specifically. Initialized in World.js
     */
  constructor() {
    const inventoryBlueText = {
      style: 'font-purple',
      fontSize: 24,
      align: 'center',
      lineSpacing: -10,
    };

    const inventoryPanel = new Phaser.Group(G.Game, null);

    const bg = G.makeImage(0, 0, 'popup_bigtext_backgr', [0.5, 0], null);
    bg.height = 90;
    bg.width = 550;

    const text = new G.Text(0, bg.y + bg.height / 2, OMT.language.getText('Help received from your friends:'), inventoryBlueText, 0.5, bg.width * 0.8, bg.height, true, 'center');
    text.x = (bg.x - bg.width * 0.45) + text.width / 2;

    inventoryPanel.addChild(bg);
    inventoryPanel.addChild(text);
    this.innerDisplay = inventoryPanel; // The static part of the inventory graphic. Also the one that tweens

    this.display = new Phaser.Group(G.Game, null);
    this.display.addChild(this.innerDisplay);   // the part that stays in place
    // this.display.scale.set(0.8, 0.8);

    this.originalBounds = inventoryPanel.getBounds().clone();
    this.renderedBounds = inventoryPanel.getBounds().clone();
    this.itemsHeight = text.y + text.height * 0.9;
    this.background = bg;
    this.items = [];    // Holds all the items

    this.trackingData = {   // Tracking for DeltaDNA
      askedBotThisLevel: false,
      numberOfMessages: 0,
      numberOfFriendsAsked: 0,
    };
  }

  /**
     * Destroy!
     */
  destroy() {
    this.display.destroy();
    this.background.destroy();
    this.clearInventory();
  }

  /**
     * Wipes inventory and tracking data
     */
  clearInventory() {
    if (this.items) {
      for (let i = 0; i < this.items.length; i++) {
        this.innerDisplay.removeChild(this.items[i].display);
        this.items[i].display.destroy();
      }
    }
    this.items = [];

    this.trackingData = {
      askedBotThisLevel: false,
      numberOfMessages: 0,
      numberOfFriendsAsked: 0,
    };
  }

  /**
     * Adds the prize to the inventory. Creates an image, but doesn't add to display
     * @param {Object} prize
     */
  addToInventory(prize) {
    if (prize.prize.indexOf('coin') > -1) {
      DDNA.transactionHelper.trackRewards([prize.prize, prize.amount], [], {
        transactionType: 'REWARD', tActionType: 'REQUEST_HELP_USE', tGameArea: game.state.getCurrentState().key === 'Game' ? 'LEVEL' : 'MAP',
      });
      G.saveState.changeCoins(prize.amount, false);
    } else {
      const giftString = OMT_UI_DrawUtil.getGiftString(prize.prize);

      const img = G.makeImage(0, 0, giftString, 0.5, null);

      const prizeData = {
        prize: prize.prize,
        amount: prize.amount,
        display: img,
      };

      this.items.push(prizeData);
    }
  }

  adjustSize(size) {
    if (size !== this.innerDisplay.scale.x) {
      // this.innerDisplay.scale.set(size, size);
      this.renderedBounds.width = this.originalBounds.width * size;
      this.renderedBounds.height = this.originalBounds.height * size;

      const tween = game.add.tween(this.innerDisplay.scale)
        .to({ x: size, y: size }, 200, Phaser.Easing.Sinusoidal.In)
        .start();
    }
  }

  /**
     * Toggles the appearance of the inventory. Either coming in or not. Tries to prevent coming in more than once
     * @param {boolean} vis
     */
  toggleInventory(vis, selfDestroy = false) {
    // console.log("!!toggleInventory = " + vis);
    // if (vis) game.world.add(this.display);

    if (this.display.visible === vis) {  // If the same, don't do anything
      return;
    }

    let givenVis = vis;
    if (givenVis === undefined) {    // If nothing was given, do a flip of it
      givenVis = !this.display.visible;  // flip
    }

    const awayY = -this.background.height * 0.3;
    let tween;
    if (givenVis) { // Tweens in
      this.innerDisplay.y = awayY;
      this.innerDisplay.alpha = 0;
      tween = game.add.tween(this.innerDisplay)
        .to({ y: 0, alpha: 1 }, 200, Phaser.Easing.Sinusoidal.In);
      this.display.visible = true;
    } else {  // Tweens out
      this.innerDisplay.y = 0;
      this.innerDisplay.alpha = 1;
      tween = game.add.tween(this.innerDisplay)
        .to({ y: awayY, alpha: 0 }, 200, Phaser.Easing.Sinusoidal.In);
      tween.onComplete.addOnce(() => {
        this.display.visible = false;
        if (selfDestroy) {
          this.destroy();
        }
        if (this.display.parent) {
          game.world.removeChild(this.display);
        }
      });
    }
    tween.start();
  }

  /**
     * Organizes the inventory, arranges it on screen, and adds them in
     */
  arrangeInventory() {
    const maxDimensions = new Phaser.Rectangle(0, this.background.y + this.background.height / 2, 80, 80);

    const spaceBetweenItems = 5;
    const totalExpectedItemWidth = (maxDimensions.width * this.items.length) + (spaceBetweenItems * (this.items.length - 1));
    const safeSpace = this.background.x + (this.background.width - this.background.width * 0.25) / 2;

    let nextX = safeSpace + (maxDimensions.width - totalExpectedItemWidth) / 2;
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i].display;
      item.width = maxDimensions.width;
      item.height = maxDimensions.height;
      item.x = nextX;
      item.y = maxDimensions.y;

      nextX += maxDimensions.width + spaceBetweenItems;

      this.innerDisplay.addChild(item);
    }
  }

  /**
     * Returns an array of flags that state which booster is gotten.
     * This is for Window_level.js, before it goes into Game, to do the prebooster things
     */
  getInventory() {
    const boosterPrefix = 'booster#';
    const rtr = [];
    for (let i = 0; i < this.items.length; i++) {
      const boosterNumber = parseInt(this.items[i].prize.split(boosterPrefix)[1], 10);
      rtr[boosterNumber] = true;
    }

    return rtr;
  }
}
